export const MODULE_NAME = 'BusinessInfoJtbdCard';

export const ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/1304981e65608bcc27d3c61e28b1d07b-1719994408098/jtbd_briefcase.png';
